import { inject } from '@angular/core'
import { ED_INJECT_EXPRESS_REQUEST } from 'src/server/server.data'
import { RuntimeService } from 'src/app/service/runtime.service'

export function i18nPath () {
  if (inject(RuntimeService).isClient()) {
    return location.pathname.slice(4)
  } else {
    const request = inject(ED_INJECT_EXPRESS_REQUEST, { optional: true })
    if (request) {
      // Path only, matching location.pathname on the client — the two used to
      // disagree for any URL with a query string, and carrying a campaign
      // parameter into a language-switch link is not wanted anyway. Also what
      // lets the SSR page cache key on the path (ED-285).
      return request.originalUrl.split(/[?#]/)[0].slice(4)
    } else {
      return ''
    }
  }
}
